// extracted by mini-css-extract-plugin
export var arrow = "_c2-2";
export var label = "_c2-1";
export var reminder = "_c2-0";